import Logos1 from "./slides/Logos1";
import Logos2 from "./slides/Logos2";

export default function LogoContainer() {
    return [
        <Logos1 key="logos-1" />,
        <Logos2 key="logos-2" />,
    ];
  }
  